import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_FAQ_START, DELETE_FAQ_ERROR, DELETE_FAQ_SUCCESS, GET_FAQ_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/faqs/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_FAQ_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_FAQ_ERROR, error });
  } finally {
    yield put({ type: GET_FAQ_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_faqs() {
  yield takeLatest(DELETE_FAQ_START, del);
}
